import { initializeApp, getApp, getApps } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyBQNKG5mP5fXWC205Ge8RQWnSH3TJrcibQ",
  authDomain: "studio-6299820334-4a5d0.firebaseapp.com",
  databaseURL: "https://studio-6299820334-4a5d0-default-rtdb.us-central1.firebasedatabase.app",
  projectId: "studio-6299820334-4a5d0",
  storageBucket: "studio-6299820334-4a5d0.firebasestorage.app",
  messagingSenderId: "363093040495",
  appId: "1:363093040495:web:e4d4aa9f0229fc1e95dc9a"
};

// Initialize Firebase
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Get a reference to the database service
export const database = getDatabase(app);
